<template>
  <div class="playlist__grids">
    <div class="playlist__grid-1 child-is-overlay">
      <img
        :src="$_gridImages[0]"
        class="img-fluid"
      >
      <slot
        v-if="!$_hasImage"
        name="empty"
      />
      <slot name="main" />
    </div>
    <div class="playlist__grid-1 child-is-overlay">
      <div class="playlist__grid-1-1">
        <img
          class="img-fluid"
          :src="$_gridImages[1]"
        >
      </div>
      <div class="playlist__grid-1-1">
        <img
          class="img-fluid"
          :src="$_gridImages[2]"
        >
      </div>
      <slot name="side" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    images: {
      type: Array as PropType<string[]>,
      default: (): string[] => [],
    },
  },
  computed: {
    // eslint-disable-next-line @typescript-eslint/camelcase
    $_gridImages(): string[] {
      return this.images.slice(0, 3);
    },
    // eslint-disable-next-line @typescript-eslint/camelcase
    $_hasImage(): boolean {
      return (this.$_gridImages.length > 0) && !!this.$_gridImages[0];
    },
  },
});
</script>

<style lang="scss">
// Math
$one-third: 100% / 3 * 1;

.playlist__grid-1 {
  position: relative;
  white-space: nowrap;
  width: $one-third * 2;
  float: left;
  height: 100%;
}
.playlist__grid-1:last-child {
  width: $one-third;
}
.playlist__grid-1 .playlist__grid-1-1 {
  position: relative;
  height: 50%;
}

// Make image take full parent size
.playlist__grids img {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.playlist__grids img:not([src]) {
  display: none;
}

// overlay stuff
.child-is-overlay {
  position: relative;
  > * {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }
}
</style>
